import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UsersList } from '@estimation/entities/user';
import { InviteUser } from '@estimation/features/inviteUser';
import styles from './styles.module.scss';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;
export function UsersPage() {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.container, children: [_jsx(Title, { level: 3, children: t('Users Management') }), _jsx("div", { className: styles.inviteButtonContainer, children: _jsx(InviteUser, {}) }), _jsx(UsersList, {})] }));
}
